import _createClass from "/usr/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/usr/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _callSuper from "/usr/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/usr/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _wrapNativeSuper from "/usr/app/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js";
import _defineProperty from "/usr/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var NotFound404Exception = /*#__PURE__*/function (_Error) {
  function NotFound404Exception(reason) {
    var _this;
    _classCallCheck(this, NotFound404Exception);
    _this = _callSuper(this, NotFound404Exception, ["Not Found Page"]);
    _defineProperty(_this, "name", "NotFound404Exception");
    _defineProperty(_this, "type", 'api error');
    _defineProperty(_this, "statusCode", 404);
    _this.trace = reason;
    return _this;
  }
  _inherits(NotFound404Exception, _Error);
  return _createClass(NotFound404Exception);
}(/*#__PURE__*/_wrapNativeSuper(Error));
export { NotFound404Exception as default };